export enum navigations {
  apps = 'navigations.apps',
  billing = 'navigations.billing',
  connections = 'navigations.connections',
  import_contacts = 'navigations.import_contacts',
  manage_users = 'navigations.manage_users',
  notifications = 'navigations.notifications',
  profile = 'navigations.profile',
  general = 'navigations.general',
}